import { createContext } from 'react';

import { LogSyncDetail } from '@totem/components/administration/logSync/details/types';

interface Context {
  loading: boolean;
  detail: LogSyncDetail | null;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  detail: null,
  onRefresh: () => {},
});
